import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createSlots as _createSlots, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3bb046e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customers list" }
const _hoisted_2 = { class: "row mb-3" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Duedate", -1))
const _hoisted_8 = { class: "col-7" }
const _hoisted_9 = {
  class: "col-3",
  style: {"padding-top":"10px"}
}
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = { class: "form-group row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "PostCode", -1))
const _hoisted_13 = { class: "col-10" }
const _hoisted_14 = { class: "custom-checkbox" }
const _hoisted_15 = ["checked", "disabled"]
const _hoisted_16 = { style: {"padding-left":"10px"} }
const _hoisted_17 = { class: "col-2" }
const _hoisted_18 = { class: "form-group row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Status", -1))
const _hoisted_20 = { class: "col-10" }
const _hoisted_21 = { class: "custom-checkbox" }
const _hoisted_22 = ["checked", "disabled"]
const _hoisted_23 = { style: {"padding-left":"10px"} }
const _hoisted_24 = { class: "col-2" }
const _hoisted_25 = { class: "form-group row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Client", -1))
const _hoisted_27 = { class: "col-10" }
const _hoisted_28 = { class: "col-2" }
const _hoisted_29 = { class: "form-group row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Branch", -1))
const _hoisted_31 = { class: "col-10" }
const _hoisted_32 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No Property Visit Management found", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["onInput", "onMousedown", "onMouseup", "onMousemove"]
const _hoisted_47 = ["onInput", "onMousedown", "onMouseup", "onMousemove"]
const _hoisted_48 = ["onInput", "onMousedown", "onMouseup", "onMousemove"]
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = ["onInput", "onMousedown", "onMouseup", "onMousemove"]

import { Booking, Inspector } from "@/models";
import { computed, onMounted, inject, ref, watch } from "vue";
import { useStore } from "vuex";
import { DxDateRangeBox } from "devextreme-vue/date-range-box";
import InspectorSelect from "@/components/propertyvisitmanagement/InspectorSelect.vue";
import ScheduledDateSelect from "@/components/propertyvisitmanagement/ScheduledDateSelect.vue";
import StatusSelect from "@/components/propertyvisitmanagement/StatusSelect.vue";
import DateRange from "@/components/propertyvisitmanagement/DateRange.vue";
import PropertyVisitPagination from "@/components/propertyvisitmanagement/PropertyVisitPagination.vue";
import { useRouter, useRoute } from 'vue-router';
import moment from "moment";

export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyVisitManagementsList',
  setup(__props) {

const pvmstate = computed(() => store.state.propertyvisitmanagement);
const store = useStore();
const postCodeOptions = ref([]);
const clientOptions = ref("");
const branchOptions = ref("");
const router = useRouter();
const route = useRoute();
const statusOptions = ref([]);
const propertyvisitmanagementData = ref<Booking[]>([]);
const hasBlockingRequests = computed(
  () => store.getters["app/hasBlockingRequests"]
);
const inspectorlist = computed(() => store.getters["diary/inspectorlist"]);
const setBookingsData = (data: Booking[]) =>
  store.commit("propertyvisitmanagement/setBookings", data);
const actProperty: any = inject("actProperty");
const getBookings = (payload: { startdate: string; enddate: string }) => {
  return store.dispatch("propertyvisitmanagement/getBookings", payload);
};
const setCurrentPage = (page: number): Promise<any> => {
  return store.dispatch('propertyvisitmanagement/setCurrentPage', page);
};
const resetCurrentPage = (page: number): Promise<any> => {
  return store.dispatch('propertyvisitmanagement/resetCurrentPage', page);
};
const dateRange = ref<[Date | null, Date | null]>([null, null]);
const changestatuspvmid = ref("");
const changeinspectorpvmid = ref("");
const changesdatepvmid = ref("");
const changesdaterangepvmid = ref("");
const computedDateRange = computed<[Date | null, Date | null]>({
  get() {
    return dateRange.value;
  },
  set(value: [Date | null, Date | null]) {
    dateRange.value = value;
    if (dateRange.value[0] && dateRange.value[1]) {
      getBookingsData();
    }
  },
});
const sortKey = ref(""); // Holds the key of the column being sorted
const sortOrder = ref<"asc" | "desc">("asc"); // Sorting order
const statusList: string[] = [
  "Select All",
  "Not due",
  "Due",
  "Scheduled and in queue",
];

// Sorting function
const sortTable = (key: string) => {
  if (sortKey.value === key) {
    // If the same column is clicked, toggle the sort order
    sortOrder.value = sortOrder.value === "asc" ? "desc" : "asc";
  } else {
    // If a new column is clicked, set to ascending order
    sortKey.value = key;
    sortOrder.value = "asc";
  }
};

// Computed property for sorted data
const sortedData = computed(() => {
  const sorted = [...propertyvisitmanagementData.value];
  // Define sorting logic based on the selected key
  if (sortKey.value) {
    sorted.sort((a, b) => {
      let compareA = a[sortKey.value] ?? "";
      let compareB = b[sortKey.value] ?? "";

      // Handle nested fields like postcode, customer, and address
      if (sortKey.value === "postcode") {
        compareA = a.address.postcode;
        compareB = b.address.postcode;
      }

      // Handle date sorting
      if (sortKey.value === "duedate") {
        compareA = new Date(a.duedate);
        compareB = new Date(b.duedate);
      }

      // Handle date sorting
      if (sortKey.value === "scheduleddate") {
        compareA = new Date(a.scheduleddate);
        compareB = new Date(b.scheduleddate);
      }

      // Handle date sorting
      if (sortKey.value === "daterangedate") {
        compareA = new Date(a.daterangestartdate);
        compareB = new Date(b.daterangeenddate);
      }

      // Handle date sorting
      if (sortKey.value === "status") {
        compareA = a.status;
        compareB = b.status;
      }

      // Handle date sorting
      if (sortKey.value === "pi") {
        compareA = a.inspector.name;
        compareB = b.inspector.name;
      }

      // Handle date sorting
      if (sortKey.value === "customer") {
        compareA = a.customer.companyName;
        compareB = b.customer.companyName;
      }

      // Handle date sorting
      if (sortKey.value === "branch") {
        compareA = a.customer.branchName;
        compareB = b.customer.branchName;
      }

      // For string comparison
      if (typeof compareA === "string") {
        compareA = compareA.toLowerCase();
        compareB = compareB.toLowerCase();
      }

      if (compareA < compareB) return sortOrder.value === "asc" ? -1 : 1;
      if (compareA > compareB) return sortOrder.value === "asc" ? 1 : -1;
      return 0;
    });
  }

  // Handle date sorting
  if (sortKey.value === "address") {
    sorted.sort((a: Booking, b: Booking) => {
      const direction = sortOrder.value === "asc" ? 1 : -1; // Determine sort direction

      // Compare `line1`
      let result = a.address.line1.localeCompare(b.address.line1) * direction;
      if (result !== 0) return result;

      // Compare `line2` (optional field)
      result = (a.address.line2 || "").localeCompare(b.address.line2 || "") * direction;
      if (result !== 0) return result;

      // Compare `town`
      result = a.address.town.localeCompare(b.address.town) * direction;
      if (result !== 0) return result;

      // Compare `county` (optional field)
      result = (a.address.county || "").localeCompare(b.address.county || "") * direction;
      if (result !== 0) return result;

      // Compare `postcode`
      return a.address.postcode.localeCompare(b.address.postcode) * direction;
    });   
  }

  let filtered = [...sorted];

  // Filter propertyvisitmanagementData based on postcodes
  // Filter by postcode if postCodeData is not empty
  if (postCodeData.value.length) {
    filtered = filtered.filter((item: Booking) =>
      postCodeData.value.includes(item.address.postcode)
    );
  }

  // Filter by status if statusData is not empty
  if (statusData.value.length) {
    // filtered = filtered.filter((item: Booking) =>
    //   statusData.value.includes(item.id) // Assuming `item.status` is the status field in `Booking`
    // );
  }

  // Filter by client
  if (clientData.value.length) {
    filtered = filtered.filter((item: Booking) =>
      clientData.value.includes(item.customer.companyName)
    );
  }
  // Filter by client
  if (branchData.value.length) {
    filtered = filtered.filter((item: Booking) =>
      branchData.value.includes(item.customer.branchName)
    );
  }

  return filtered;
});
const postCodeData = computed({
  get() {
    return postCodeOptions.value;
  },
  set(val: string[]) {
    if (
      val.includes("Select All") &&
      !postCodeOptions.value.includes("Select All")
    ) {
      postCodeOptions.value = uniquePostcodes.value;
    } else if (
      !val.includes("Select All") &&
      postCodeOptions.value.includes("Select All")
    ) {
      postCodeOptions.value = [];
    } else {
      postCodeOptions.value = val.filter((f: any) => f !== "Select All");
    }
  },
});
const clientData = computed({
  get() {
    return clientOptions.value;
  },
  set(val: string) {
    clientOptions.value = val;
  },
});
const branchData = computed({
  get() {
    return branchOptions.value;
  },
  set(val: string) {
    branchOptions.value = val;
  },
});
const statusData = computed({
  get() {
    return statusOptions.value;
  },
  set(val: string[]) {
    if (
      val.includes("Select All") &&
      !statusOptions.value.includes("Select All")
    ) {
      statusOptions.value = statusList;
    } else if (
      !val.includes("Select All") &&
      statusOptions.value.includes("Select All")
    ) {
      statusOptions.value = [];
    } else {
      statusOptions.value = val.filter((f: any) => f !== "Select All");
    }
  },
});
const formatDate = (date: Date) => {
  return moment(date).format("DD-MM-YYYY");
};
watch(() => route.query.page, async (newVal: any, oldVal: any) => {
  if (newVal) {
    await setCurrentPage(newVal);
    await getBookingsData();
  }
});
const propertyvisitmanagement = computed(
  () => store.getters["propertyvisitmanagement/getBookingsData"]
);
const getBookingsData = async () => {
  if (dateRange.value[0] && dateRange.value[1]) {
    // Format the start and end dates and make the API call
    await getBookings({
      startdate: formatDate(dateRange.value[0]), // Format the start date
      enddate: formatDate(dateRange.value[1]), // Format the end date
    });
  } else {
    await getBookings({
      startdate: "", // Format the start date
      enddate: "", // Format the end date
    });
  }
  propertyvisitmanagementData.value = propertyvisitmanagement.value;
};
const uniquePostcodes = computed(() => {
  let postcodes = propertyvisitmanagement.value.map(
    (f: Booking) => f.address.postcode
  );

  // Remove duplicates using Set and convert back to an array
  const uniquePostcodesArray = Array.from(new Set(postcodes));

  // Add 'Select All' at the 0th index
  return ["Select All", ...uniquePostcodesArray];
});
const uniqueClients = computed(() => {
  let clients = propertyvisitmanagement.value.map(
    (f: Booking) => f.customer.companyName
  );

  // Remove duplicates using Set and convert back to an array
  const uniquePostcodesArray = Array.from(new Set(clients));

  // Add 'Select All' at the 0th index
  return [...uniquePostcodesArray];
});
const uniqueBranch = computed(() => {
  if (!clientData.value) return [];
  let clients = propertyvisitmanagement.value
    .filter((f: Booking) => f.customer.companyName == clientData.value)
    .map((f: Booking) => f.customer.branchName);

  // Remove duplicates using Set and convert back to an array
  const uniquePostcodesArray = Array.from(new Set(clients));

  // Add 'Select All' at the 0th index
  return [...uniquePostcodesArray];
});

// Converted methods
const init = async () => {
  await getBookingsData();
};
const showAll = async () => {
  dateRange.value = [null, null]; // Reset date range
  resetCurrentPage(1);
  setCurrentPage(1);
  await getBookingsData();
};
const minDate = new Date("2020-01-01"); // Very old date (acts as "infinity" in the past)
const maxDate = new Date("2050-12-31"); // Very distant future date (acts as "infinity" in the future)
// Lifecycle hook
onMounted(() => {
  init();
});

// Reactive state for drag-to-fill functionality
const dragging = ref(false);
const startRow = ref<number | null>(null);
const startValue = ref<string | null>(null);
const endValue = ref<string | null>(null);
const endRow = ref<number | null>(null);
// Function to get the inspector ID based on the name and set it in the appropriate cell
const getUpdateFieldById = (
  rowIndex: number,
  name: string,
  id: string,
  fieldname: string
) => {
  const pmIndex = propertyvisitmanagement.value.findIndex(
    (r: Booking) => r.id === id
  );
  if (fieldname === "inspector") {
    const inspector = inspectorlist.value.find(
      (f: Inspector) => f.name === name
    );
    if (inspector?.id) {
      sortedData.value[rowIndex].inspector.id = inspector.id;
      sortedData.value[rowIndex].inspector.name = name;
      propertyvisitmanagement.value[pmIndex].inspector = inspector;
    }
  } else if (fieldname === "status") {
    sortedData.value[rowIndex].status = name;
    propertyvisitmanagement.value[pmIndex].status = name;
  } else if (fieldname === "scheduleddate" && name !== null) {
    sortedData.value[rowIndex].scheduleddate = name;
    propertyvisitmanagement.value[pmIndex].scheduleddate = name;
  } else if (fieldname === "daterange" && name !== null) {
    sortedData.value[rowIndex].daterangestartdate = name;
    propertyvisitmanagement.value[pmIndex].daterangestartdate = name;
    sortedData.value[rowIndex].daterangeenddate = endValue.value;
    propertyvisitmanagement.value[pmIndex].daterangeenddate =  endValue.value
  }
  setBookingsData(propertyvisitmanagement.value);
};

// Function to update the cell value when a user enters data
const updateCellValue = (
  event: InputEvent,
  rowIndex: number,
  id: string,
  fieldname: string
) => {
  const value = (event.target as HTMLElement).innerText;
  getUpdateFieldById(rowIndex, value, id, fieldname);
};

// Function to initiate drag-to-fill (stores initial row and value)
const startDrag = (rowIndex: number, id: string, fieldname: string) => {
  dragging.value = true;
  startRow.value = rowIndex;
  if (fieldname === "inspector") {
    startValue.value = sortedData.value[rowIndex].inspector.name; // Capture the initial value
  } else if (fieldname === "status") {
    startValue.value = sortedData.value[rowIndex].status; // Capture the initial value
  } else if (fieldname === "scheduleddate") {
    startValue.value = sortedData.value[rowIndex].scheduleddate; // Capture the initial value
  } else if (fieldname === "daterange") {
    startValue.value = sortedData.value[rowIndex].daterangestartdate; // Capture the initial value
    endValue.value = sortedData.value[rowIndex].daterangeenddate; // Capture the initial value
  }
  getUpdateFieldById(rowIndex, startValue.value, id, fieldname);
  endRow.value = rowIndex; // Initialize endRow as startRow to reset drag boundaries
};

// Function to finalize the drag-to-fill action, filling cells downward only
const endDrag = (id: string, fieldname: string) => {
  if (
    dragging.value &&
    startRow.value !== null &&
    startValue.value !== null &&
    endRow.value !== null &&
    endRow.value > startRow.value // Ensure we’re only dragging downward
  ) {
    dragging.value = false;

    // Fill cells only downward from startRow to endRow
    const start = startRow.value;
    const end = endRow.value;

    for (let i = start; i <= end; i++) {
      getUpdateFieldById(i, startValue.value, id, fieldname);
    }
  }
  // Reset start and end rows after drag
  startRow.value = null;
  endRow.value = null;
};

// Function to track the drag row index (determines the end row)
// Only allow downward dragging (endRow >= startRow)
const handleDrag = (rowIndex: number, fieldname: string) => {
  if (dragging.value && rowIndex > startRow.value) {
    endRow.value = rowIndex;
  }
};
const doReportsPaging = (page: number): void => {
  setCurrentPage(page);
  const queryParams = { ...route.query };
  queryParams.page = page + ""; // hack to coerce to string
  router.push({ path: "propertyvisitmanagements", query: queryParams });
}

return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(DxDateRangeBox), {
                  modelValue: computedDateRange.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((computedDateRange).value = $event)),
                  min: _unref(minDate),
                  max: _unref(maxDate),
                  displayFormat: "dd/MM/yyyy",
                  label: "Select Date Range"
                }, null, 8, ["modelValue", "min", "max"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showAll()))
                }, " Show All ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_multiselect_text, {
                  modelValue: postCodeData.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((postCodeData).value = $event)),
                  options: uniquePostcodes.value,
                  multiple: "",
                  "close-on-select": false,
                  allowEmpty: true,
                  taggable: ""
                }, {
                  option: _withCtx(({ option, selected, disabled }) => [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: postCodeData.value.includes(option),
                        disabled: disabled
                      }, null, 8, _hoisted_15),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(option), 1)
                    ])
                  ]),
                  selection: _withCtx(({ values, search, isOpen }) => [
                    (values.length)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "multiselect__single"
                        }, _toDisplayString(values.length) + " options selected", 513)), [
                          [_vShow, !isOpen]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_multiselect_text, {
                  modelValue: statusData.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((statusData).value = $event)),
                  options: statusList,
                  multiple: "",
                  "close-on-select": false,
                  allowEmpty: true,
                  taggable: ""
                }, {
                  option: _withCtx(({ option, selected, disabled }) => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: statusData.value.includes(option),
                        disabled: disabled
                      }, null, 8, _hoisted_22),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(option), 1)
                    ])
                  ]),
                  selection: _withCtx(({ values, search, isOpen }) => [
                    (statusData.value.length)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "multiselect__single"
                        }, _toDisplayString(statusData.value.length) + " options selected", 513)), [
                          [_vShow, !isOpen]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_singleselect_text, {
                  modelValue: clientData.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((clientData).value = $event)),
                  options: uniqueClients.value,
                  "allow-empty": true,
                  taggable: false
                }, _createSlots({ _: 2 }, [
                  (clientData.value)
                    ? {
                        name: "clear",
                        fn: _withCtx(() => [
                          _createElementVNode("i", {
                            onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (clientData.value = ''), ["prevent","stop"])),
                            class: "multiselect__clear fa fa-times",
                            "aria-label": "Clear Client"
                          }, null, 32)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_singleselect_text, {
                  modelValue: branchData.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((branchData).value = $event)),
                  options: uniqueBranch.value,
                  "allow-empty": true,
                  taggable: false
                }, _createSlots({ _: 2 }, [
                  (branchData.value)
                    ? {
                        name: "clear",
                        fn: _withCtx(() => [
                          _createElementVNode("i", {
                            onMousedown: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (branchData.value = ''), ["prevent","stop"])),
                            class: "multiselect__clear fa fa-times",
                            "aria-label": "Clear Branch"
                          }, null, 32)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "options"])
              ])
            ])
          ])
        ])
      ])
    ]),
    (!propertyvisitmanagement.value.length && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
      : (_openBlock(), _createElementBlock("table", _hoisted_35, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (sortTable('jobtype'))),
                class: "jobtype"
              }, [
                _createTextVNode(" Jobtype "),
                (sortKey.value === 'jobtype')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(sortOrder.value === "asc" ? "▲" : "▼"), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (sortTable('duedate'))),
                class: "duedate"
              }, [
                _createTextVNode(" Due Date "),
                (sortKey.value === 'duedate')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(sortOrder.value === "asc" ? "▲" : "▼"), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (sortTable('scheduleddate'))),
                class: "scheduledate"
              }, [
                _createTextVNode(" Scheduled Date "),
                (sortKey.value === 'scheduleddate')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(sortOrder.value === "asc" ? "▲" : "▼"), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (sortTable('daterangedate'))),
                class: "daterangedate"
              }, [
                _createTextVNode("Date Range "),
                (sortKey.value === 'daterangedate')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(sortOrder.value === "asc" ? "▲" : "▼"), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (sortTable('status'))),
                class: "status"
              }, [
                _createTextVNode("Status "),
                (sortKey.value === 'status')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(sortOrder.value === "asc" ? "▲" : "▼"), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (sortTable('postcode'))),
                class: "postcode"
              }, [
                _createTextVNode(" PostCode "),
                (sortKey.value === 'postcode')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(sortOrder.value === "asc" ? "▲" : "▼"), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (sortTable('address'))),
                class: "address"
              }, [
                _createTextVNode("Address "),
                (sortKey.value === 'address')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(sortOrder.value === "asc" ? "▲" : "▼"), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[15] || (_cache[15] = ($event: any) => (sortTable('pi'))),
                class: "pi"
              }, [
                _createTextVNode("PI "),
                (sortKey.value === 'pi')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(sortOrder.value === "asc" ? "▲" : "▼"), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[16] || (_cache[16] = ($event: any) => (sortTable('customer'))),
                class: "customer"
              }, [
                _createTextVNode("Customer "),
                (sortKey.value === 'customer')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(sortOrder.value === "asc" ? "▲" : "▼"), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("th", {
                onClick: _cache[17] || (_cache[17] = ($event: any) => (sortTable('branch'))),
                class: "branch"
              }, [
                _createTextVNode("Branch "),
                (sortKey.value === 'branch')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(sortOrder.value === "asc" ? "▲" : "▼"), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedData.value, (pvm, rowIndex) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: pvm.id
              }, [
                _createElementVNode("td", null, _toDisplayString(pvm.jobtype.toLocaleUpperCase()), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(actProperty).formatDateForDisplay(pvm.duedate)), 1),
                _createElementVNode("td", {
                  contenteditable: "false",
                  onInput: ($event: any) => (updateCellValue($event, rowIndex, pvm.id, 'scheduleddate')),
                  onMousedown: ($event: any) => (startDrag(rowIndex, pvm.id, 'scheduleddate')),
                  onMouseup: ($event: any) => (endDrag(pvm.id, 'scheduleddate')),
                  onMousemove: ($event: any) => (handleDrag(rowIndex, 'scheduleddate')),
                  class: "no-select"
                }, [
                  _createVNode(ScheduledDateSelect, {
                    pvm: pvm,
                    changesdatepvmid: changesdatepvmid.value,
                    onSchedulatedatepvmselected: _cache[18] || (_cache[18] = ($event: any) => (changesdatepvmid.value = $event))
                  }, null, 8, ["pvm", "changesdatepvmid"])
                ], 40, _hoisted_46),
                _createElementVNode("td", {
                  contenteditable: "false",
                  onInput: ($event: any) => (updateCellValue($event, rowIndex, pvm.id, 'daterange')),
                  onMousedown: ($event: any) => (startDrag(rowIndex, pvm.id, 'daterange')),
                  onMouseup: ($event: any) => (endDrag(pvm.id, 'daterange')),
                  onMousemove: ($event: any) => (handleDrag(rowIndex, 'daterange')),
                  class: "no-select"
                }, [
                  _createVNode(DateRange, {
                    pvm: pvm,
                    changesdaterangepvmid: changesdaterangepvmid.value,
                    onDaterangepvmselected: _cache[19] || (_cache[19] = ($event: any) => (changesdaterangepvmid.value = $event))
                  }, null, 8, ["pvm", "changesdaterangepvmid"])
                ], 40, _hoisted_47),
                _createElementVNode("td", {
                  contenteditable: "false",
                  onInput: ($event: any) => (updateCellValue($event, rowIndex, pvm.id, 'status')),
                  onMousedown: ($event: any) => (startDrag(rowIndex, pvm.id, 'status')),
                  onMouseup: ($event: any) => (endDrag(pvm.id, 'status')),
                  onMousemove: ($event: any) => (handleDrag(rowIndex, 'status')),
                  class: "no-select"
                }, [
                  _createVNode(StatusSelect, {
                    pvm: pvm,
                    changestatuspvmid: changestatuspvmid.value,
                    onStatuspvmselected: _cache[20] || (_cache[20] = ($event: any) => (changestatuspvmid.value = $event))
                  }, null, 8, ["pvm", "changestatuspvmid"])
                ], 40, _hoisted_48),
                _createElementVNode("td", null, _toDisplayString(pvm.address.postcode), 1),
                _createElementVNode("td", {
                  innerHTML: _unref(actProperty).formatAddress(pvm.address, ', ')
                }, null, 8, _hoisted_49),
                _createElementVNode("td", {
                  contenteditable: "false",
                  onInput: ($event: any) => (updateCellValue($event, rowIndex, pvm.id, 'inspector')),
                  onMousedown: ($event: any) => (startDrag(rowIndex, pvm.id, 'inspector')),
                  onMouseup: ($event: any) => (endDrag(pvm.id, 'inspector')),
                  onMousemove: ($event: any) => (handleDrag(rowIndex, 'inspector')),
                  class: "no-select"
                }, [
                  _createVNode(InspectorSelect, {
                    pvm: pvm,
                    changeinspectorpvmid: changeinspectorpvmid.value,
                    onInspectorpvmselected: _cache[21] || (_cache[21] = ($event: any) => (changeinspectorpvmid.value = $event))
                  }, null, 8, ["pvm", "changeinspectorpvmid"])
                ], 40, _hoisted_50),
                _createElementVNode("td", null, _toDisplayString(pvm.customer.companyName), 1),
                _createElementVNode("td", null, _toDisplayString(pvm.customer.branchName), 1)
              ]))
            }), 128))
          ])
        ])),
    (sortedData.value.length)
      ? (_openBlock(), _createBlock(PropertyVisitPagination, {
          key: 2,
          total: pvmstate.value.totalcount,
          current: pvmstate.value.currentPage,
          limit: pvmstate.value.pageLimit,
          onPageReports: doReportsPaging
        }, null, 8, ["total", "current", "limit"]))
      : _createCommentVNode("", true)
  ]))
}
}

})